import React, { Component } from 'react';
import { injectIntl, defineMessages } from 'react-intl';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { Tooltip } from 'material-ui';

import classNames from 'classnames/bind';
import styles from './Declare.css';
const cx = classNames.bind(styles);

class DeclareHeaderTab extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const { currentPath } = this.props;

    return (
      <div className={cx('declare-sub-tab')}>
        <Tooltip
          title={defineMessages(
            formatMessage({
              id: 'ExamHeader_13',
              defaultMessage: "신고 내역을 '훈련'별로 보여줍니다."
            })
          )}
          classes={{ tooltip: 'tooltip-noMaxWidth' }}
          placement="bottom">
          <NavLink
            exact
            to="/main/declaration/exam"
            className={cx('sub-tab-item', {
              selected: currentPath === '/main/declaration/exam'
            })}>
            <span className={cx('link-text')}>
              {defineMessages(formatMessage({ id: 'DeclareHeader_1', defaultMessage: '훈 련' }))}
            </span>
          </NavLink>
        </Tooltip>
        <Tooltip
          title={defineMessages(
            formatMessage({
              id: 'ExamHeader_13',
              defaultMessage: "신고 내역을 '메일'별로 보여줍니다."
            })
          )}
          classes={{ tooltip: 'tooltip-noMaxWidth' }}
          placement="bottom">
          <NavLink
            exact
            to="/main/declaration/mail"
            className={cx('sub-tab-item', {
              selected: currentPath === '/main/declaration/mail'
            })}>
            <span className={cx('link-text')}>
              {defineMessages(formatMessage({ id: 'DeclareHeader_2', defaultMessage: '메 일' }))}
            </span>
          </NavLink>
        </Tooltip>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  currentPath: state.currentStatus.getIn(['path', 'current'])
});

export default connect(mapStateToProps)(injectIntl(DeclareHeaderTab));


// WEBPACK FOOTER //
// ./src/script/components/declare/DeclareHeaderTab.js